import { Dialog } from "@ariakit/react";
import {
  AuthCardV2,
  ListItemContainer,
  ListItemContent,
  ListItemHeading,
  ListItemSummary,
  ListView,
  MiddotSeparated,
  MinWidth,
  useMediaQuery,
} from "@indietabletop/appkit";
import { interactiveText } from "@indietabletop/appkit/common.css.ts";
import { Link } from "wouter";
import { latest } from "../../engine/latest";
import { useSidenavStore } from "./SidenavContext";
import logoSrc from "./logo.png";
import { navLinks } from "./navLinks";
import { sidenav, sidenavListViewItem } from "./style.css";

function SidenavListItem(props: {
  heading: string;
  summary: string;
  href: string;
}) {
  const { heading, summary, href } = props;

  return (
    <ListItemContainer>
      <ListItemContent
        render={<Link href={href} />}
        className={sidenavListViewItem.content}
      >
        <ListItemHeading className={sidenavListViewItem.heading}>
          {heading}
        </ListItemHeading>

        <ListItemSummary className={sidenavListViewItem.summary}>
          {summary}
        </ListItemSummary>
      </ListItemContent>
    </ListItemContainer>
  );
}

export function Sidenav() {
  const store = useSidenavStore();
  const isMediumOrWider = useMediaQuery(MinWidth.MEDIUM);

  // Within the sidenav, if the user clicks an interactive element like an
  // anchor or a button, the sidenav should close.
  const closeOnInteractiveElementClick = (
    event: React.MouseEvent<HTMLDivElement>,
  ) => {
    if (
      event.target instanceof HTMLElement &&
      event.target.closest("a, button")
    ) {
      store.hide();
    }
  };

  return (
    <Dialog
      store={store}
      modal={!isMediumOrWider}
      className={sidenav.container}
      onClick={closeOnInteractiveElementClick}
    >
      <Link href="~/" className={sidenav.logoLink}>
        <img
          src={logoSrc}
          alt="Greathelm"
          className={sidenav.logo}
          width={472}
          height={112}
        />
      </Link>

      <ListView>
        {navLinks.map((link) => {
          return <SidenavListItem key={link.href} {...link} />;
        })}
      </ListView>

      <div className={sidenav.info}>
        <div>Ruleset v{latest.version} (early access)</div>

        <MiddotSeparated>
          <Link className={interactiveText} href="~/settings">
            Settings
          </Link>

          <Link className={interactiveText} href="~/docs/help/about">
            About
          </Link>
        </MiddotSeparated>
      </div>

      <AuthCardV2 description="Enable backup & sync, unlock owned content, and more!" />
    </Dialog>
  );
}
